import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class WorkingArea extends PureComponent {
  static propTypes = {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    w: PropTypes.number.isRequired,
    h: PropTypes.number.isRequired,
    draggingOpts: PropTypes.object.isRequired,
    works: PropTypes.array.isRequired,
    pixelsToInches: PropTypes.func.isRequired,
    renderWork: PropTypes.func.isRequired,
    setCenter: PropTypes.func.isRequired,
    resetCenter: PropTypes.func.isRequired
  };

  componentDidMount() {
    const {
      w, h, pixelsToInches, resetCenter
    } = this.props;
    const { x, y } = pixelsToInches({ x: w, y: h });
    resetCenter(x, y);
  }

  componentDidUpdate(prevProps) {
    const {
      x, y, w, h
    } = this.props;
    const {
      x: wasX, y: wasY, w: wasW, h: wasH
    } = prevProps;
    if (x !== wasX || y !== wasY || w !== wasW || h !== wasH) {
      this.setCenter();
    }
  }

  setCenter() {
    const {
      x, y, w, h, pixelsToInches, setCenter
    } = this.props;
    const cX = (w / 2) - x;
    const cY = (h / 2) - y;
    const { x: centerX, y: centerY } = pixelsToInches({ x: cX, y: cY });
    const { x: posX, y: posY } = pixelsToInches({ x: -x, y: -y });
    setCenter(centerX, centerY, posX, posY);
  }

  render() {
    const {
      works, draggingOpts, renderWork // , x, y
    } = this.props;
    return (
      <>
        { works.map((work, index) => renderWork(draggingOpts, work, index)) }
      </>
    );
  }
}
